import React, { createContext, useContext, useState } from "react";
import "./toast.scss";
import ToasterIcon from "./toasterIcons";
import useScreenMobile from "hooks/useScreen";

// Create Context
const ToastContext = createContext();

// Provider Component
export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);
  const [visible, setVisible] = useState(false);

  const isMobile = useScreenMobile({ size: 730 });

  // Function to show toast
  const showToast = (message, type = "success") => {
    if (typeof message === "string" && typeof type === "string") {
      setToast({ message, type });
      setVisible(true);

      // Hide toast after 3 seconds
      setTimeout(() => {
        setVisible(false);
        setTimeout(() => {
          setToast(null);
        }, 500); // Delay removal for smooth exit animation
      }, 3000);
    }
  };

  const closeHandler = () => {
    setVisible(false);
    setTimeout(() => {
      setToast(null);
    }, 500); // Delay removal for exit animation
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          visible={visible}
          closeHandler={closeHandler}
          isMobile={isMobile} // Pass isMobile to the Toast component
        />
      )}
    </ToastContext.Provider>
  );
};

// Hook to use toast in any component
export const useToast = () => useContext(ToastContext);

// Toast Component
const Toast = ({ message, type, visible, closeHandler, isMobile }) => {
  return (
    <div className={`toast ${type} ${visible ? "show" : "hide"}`}>
      <div className="box">
        <div
          className="icon"
          style={{
            background:
              type === "success"
                ? "rgba(38, 199, 11, 0.10)"
                : type === "error"
                  ? "rgba(240, 66, 72, 0.10)"
                  : type === "warning"
                    ? "rgba(245, 183, 0, 0.10)"
                    : "rgba(240, 66, 72, 0.10)"
          }}
        >
          <ToasterIcon type={type} />
        </div>
        <p className="text">{message}</p>
      </div>
      <div onClick={closeHandler} style={{ cursor: "pointer" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={isMobile ? "20" : "40"} // Use isMobile here
          height={isMobile ? "20" : "40"} // Use isMobile here
          viewBox="0 0 40 40"
          fill="none"
        >
          <g clipPath="url(#clip0_1596_71936)">
            <path
              d="M28.182 11.8184L11.8184 28.182"
              stroke="#99939F"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11.8184 11.8184L28.182 28.182"
              stroke="#99939F"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1596_71936">
              <rect width="40" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};
